"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
const Animations_1 = require("components/styled/Animations");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
const rocket = require(`../../../img/rocket-2x.jpg`);
const Wrapper = styled_components_1.default.div `
  animation: ${Animations_1.fadein(0, 40)} 1s ease-out;
  display: none;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    bottom: 0;
    display: block;
    line-height: 0;
    margin-bottom: -130px;
    position: absolute;
    left: -320px;
  }

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    left: -380px;
    margin-bottom: -150px;
  }

  ${ScreenSizes_1.DESKTOP} {
    left: -500px;
    margin-bottom: -180px;
  }
`;
const Img = styled_components_1.default.img `
  ${ScreenSizes_1.TABLET_PORTRAIT} {
    max-width: 900px;
  }

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    max-width: 1000px;
  }

  ${ScreenSizes_1.DESKTOP} {
    max-width: 1300px;
  }
`;
exports.Rocket = () => {
    return (React.createElement(Wrapper, null,
        React.createElement(Img, { src: rocket })));
};



// WEBPACK FOOTER //
// ./src/components/styled/img/Rocket.tsx